var _rect, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuardianType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 24,
    fill: "#F1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.3333 27.9993C42.3333 32.0172 40.5562 35.6199 37.7451 38.0644C35.404 40.1002 32.3459 41.3327 29 41.3327C25.654 41.3327 22.5959 40.1002 20.2548 38.0644C17.4438 35.6199 15.6666 32.0172 15.6666 27.9993C15.6666 20.6356 21.6362 14.666 29 14.666C36.3638 14.666 42.3333 20.6356 42.3333 27.9993Z",
    fill: "#1C0054"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 25.332,
    r: 4,
    fill: "#1C0054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 38.0651C36.4205 34.5224 33.0048 32 29 32C24.9952 32 21.5795 34.5224 20.2549 38.0651C22.5959 40.1008 25.654 41.3333 29 41.3333C32.346 41.3333 35.4041 40.1008 37.7451 38.0651Z",
    fill: "#1C0054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardianType);
export default __webpack_public_path__ + "static/media/guardian-type.ea0e5fef28519bd1c84f7e73e12e872c.svg";
export { ForwardRef as ReactComponent };